/*
 * File: theme-button.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:50:12
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { retrieveTheme, Theme } from "@root/core/theme";
import { BaseComponent } from "@root/components/base-classes";

/// refined at 2023/12/13
@Component
export default class ThemeButton extends BaseComponent {
    /// private helpers
    // retrieve current applying theme
    currentThemeKey(): string | undefined {
        let themeUnit = retrieveTheme(this.$theme);
        return themeUnit ? themeUnit.key : undefined;
    }
    // get all available themes
    get themeList() {
        let themeList = Theme.list();
        return Object.keys(themeList).reduce((final, key) => {
            const themeUnit = themeList[key];
            final[themeUnit.key] = themeUnit.name;
            return final;
        }, {});
    }
    // update current theme!
    updateTheme(key: string) {
        let themeList = Theme.list();
        (this.$observables.$theme as any).next(themeList[key].element);
    }
}
